import React from 'react';
import axios from "axios";
import fileDownload from "js-file-download";

//Create JSON file for adding assignments
export async function DownloadJSONFile(file, name){
    const json = JSON.stringify(file)
    const blob = new Blob([json], {type: 'application/json'});
    const href = await URL.createObjectURL(blob);
    axios.get(href, {
        responseType: 'blob',
    })
        .then((res) => {
            fileDownload(res.data, 'assignment'+ (name.length+1))
        })
}
